import MediaComponent from "./components/MediaComponent.vue";
import YouTubeSettings from "./components/YouTubeSettings.vue";

const mediaPlugin = {
  install(app) {
    app.component("media-component", MediaComponent);
    app.component("youtube-settings", YouTubeSettings);
  },
};

export default mediaPlugin;
